import { useEffect, useRef, useState } from "react";

/**
 * Shared hook for territory assignment logic
 *
 * @param {Object[]} territories - All available territories
 * @param {Object[] | null} initialTerritories - Prefill (Edit page only)
 */
export default function useTerritoryAssignment({
  territories = [],
  initialTerritories = null,
}) {
  const [assignToTerritory, setAssignToTerritory] = useState(false);
  const [selectedTerritories, setSelectedTerritories] = useState([]);

  // Prevent re-initialization after first load
  const hasInitialized = useRef(false);

  useEffect(() => {
    if (
      hasInitialized.current ||
      !initialTerritories ||
      initialTerritories.length === 0 ||
      territories.length === 0
    ) {
      return;
    }

    const matched = initialTerritories
      .map((init) =>
        territories.find(
          (t) =>
            t.id === init.id ||
            (t.name &&
              init.name &&
              t.name.toLowerCase() === init.name.toLowerCase())
        )
      )
      .filter(Boolean);

    if (matched.length > 0) {
      setSelectedTerritories(matched);
      setAssignToTerritory(true);
    }

    hasInitialized.current = true;
  }, [initialTerritories, territories]);

  const toggleAssignToTerritory = (enabled) => {
    setAssignToTerritory(enabled);
    if (!enabled) {
      setSelectedTerritories([]);
    }
  };

  return {
    assignToTerritory,
    setAssignToTerritory: toggleAssignToTerritory,
    selectedTerritories,
    setSelectedTerritories,
  };
}
